import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import pl from './pl.json';
import en from './en.json';

/**
 * react-i18next init (per spec §4.13: PL+EN; default PL, fallback EN).
 *
 * Detection order: localStorage `i18nextLng` → navigator → htmlTag → default 'pl'.
 * Persistence: localStorage. Po wyborze locale w settings (T27 PatchMe), update detector cache + i18n.changeLanguage.
 */

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: ['pl', 'en'],
    interpolation: {
      escapeValue: false, // React już escape'uje
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export { i18n };
export default i18n;
